import { mapGetters } from 'vuex'

export const videoBookmarks = {
  computed: {
    ...mapGetters({
      courseBookmarks: 'content/courseBookmarks',
    }),
    videoBookmarks() {
      return this.courseBookmarks.reduce((acc, bookmark) => {
        if (
          bookmark.video === this.content.id &&
          bookmark.metadata.course_id === this.content.parent_id
        )
          acc.push({
            begin: bookmark.time,
            cueType: 'bookmark',
            text: bookmark.notes,
          })
        return acc
      }, [])
    },
  },
  methods: {
    _addBookmarksClues() {
      // jwPlayer instance
      if (this.instance) this.instance.addCues(this.videoBookmarks)
    },
  },
  watch: {
    courseBookmarks() {
      this._addBookmarksClues()
    },
  },
}
